import { BaseNodeModel } from "../BaseNodeModel";
import { PREDICATE } from "../ConstantNames";
export class TernaryNodeModel extends BaseNodeModel {
  constructor(options = {}) {
    super({
      type: 'ternary',
      ...options
    });
  }

  removeElementFromMathView(name, type) {
    let removeElementFunction = type === PREDICATE ? this.getReduxProps()["removeTernaryPredicate"] : this.getReduxProps()["removeBinaryFunction"];
    removeElementFunction(name, this.getNodeNameCombination());
  }

  addElementToMathView(name, type) {
    let addElementFunction = type === PREDICATE ? this.getReduxProps()["addTernaryPredicate"] : this.getReduxProps()["addBinaryFunction"];
    addElementFunction(name, this.getNodeNameCombination());
  }

  removeNodeFromGraphView() {
    this.getReduxProps()["removeTernaryNode"](this.getNodeName());
  }

}